module.exports = __webpack_public_path__ + "img/black-sapote-350x184.81a37f60.jpg";